import React, { FC } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { IServiceByProvider } from "../types";
import { CategoryServiceCard } from "./CategoryServiceCard";
import Error from "../../../components/Error";

interface ICategoryServiceListProps {
  list: IServiceByProvider[];
}

const useStyles = makeStyles(() => ({
  categoryCard: {
    minWidth: 600,
  },
}));

const CategoryServiceList: FC<ICategoryServiceListProps> = ({ list }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {list.length === 0 ? (
        <Error icon={"search"} text={"You have no results for now."} />
      ) : (
        list.map(({ id, countries, providerImagePath, providerName }) => (
          <Grid item xs={12} sm={12} md={6} className={classes.categoryCard}>
            <CategoryServiceCard
              key={id}
              id={id}
              countries={countries}
              providerImagePath={providerImagePath}
              providerName={providerName}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default React.memo(CategoryServiceList);
